/* Buonanno | Explicit size selection | only product detail page. */
(() => {
  if (window.__buonannoSizeSelectionInstalled) return;
  window.__buonannoSizeSelectionInstalled = true;

  const confirmed = new Set();
  const matchesSize = (name) => /^(taglia|size|taille|talla|größe|gr[oö]sse)$/i.test((name || '').trim());
  const pickers = () => document.querySelectorAll('main variant-picker[data-template-product-match="true"]');

  function sizeControl(picker) {
    const radios = [...picker.querySelectorAll('input[type="radio"][data-option-name]')].filter(input => matchesSize(input.dataset.optionName));
    const selects = [...picker.querySelectorAll('select')].filter(select =>
      [...select.options].some(option => matchesSize(option.dataset.optionName))
    );
    return { radios, selects };
  }

  function scopeFor(picker) {
    return picker.closest('.shopify-section') || picker.closest('section');
  }

  function sync(picker) {
    if (!picker.isConnected || picker.closest('quick-add-dialog, product-card')) return;
    const { radios, selects } = sizeControl(picker);
    if (!radios.length && !selects.length) return;
    const id = picker.dataset.productId || '';
    const isConfirmed = confirmed.has(id);

    if (!isConfirmed) {
      radios.forEach(input => {
        if (input.checked) input.checked = false;
        if (input.dataset.currentChecked !== 'false') input.dataset.currentChecked = 'false';
      });
      selects.forEach(select => {
        if (select.selectedIndex !== -1) select.selectedIndex = -1;
      });
    }
    const valid = isConfirmed && (radios.some(input => input.checked && !input.disabled && input.dataset.optionAvailable !== "false") || selects.some(select => select.selectedIndex >= 0 && !!select.value && !select.selectedOptions[0]?.disabled));
    const scope = scopeFor(picker);
    if (!scope) return;
    scope.querySelectorAll('product-form-component').forEach(formComponent => {
      formComponent.querySelectorAll('button[name="add"], add-to-cart-component button').forEach(button => {
        if (!valid && !button.disabled) button.disabled = true;
        if (!valid) button.setAttribute('aria-label', 'Seleziona una taglia prima di aggiungere al carrello');
      });
      formComponent.querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout').forEach(element => {
        if (!valid) {
          if (element.dataset.buonannoPriorDisplay === undefined) element.dataset.buonannoPriorDisplay = element.style.display || '';
          if (element.style.display !== 'none') element.style.display = 'none';
        } else if (element.dataset.buonannoPriorDisplay !== undefined) {
          element.style.display = element.dataset.buonannoPriorDisplay;
          delete element.dataset.buonannoPriorDisplay;
        }
      });
    });
  }

  function syncAll() { pickers().forEach(sync); }
  document.addEventListener('change', event => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    const picker = target.closest('variant-picker[data-template-product-match="true"]');
    if (!picker || ![...pickers()].includes(picker)) return;
    const { radios, selects } = sizeControl(picker);
    if (radios.includes(target) && (target.disabled || target.dataset.optionAvailable === "false")) { event.preventDefault(); return; }
    if (radios.includes(target) || selects.includes(target)) {
      confirmed.add(picker.dataset.productId || '');
    }
    queueMicrotask(syncAll);
    setTimeout(syncAll, 60);
  }, true);

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const section = form.closest('.shopify-section') || form.closest('section');
    const picker = section?.querySelector('variant-picker[data-template-product-match="true"]');
    if (!picker || !form.closest('product-form-component')) return;
    const { radios, selects } = sizeControl(picker);
    if (!radios.length && !selects.length) return;
    const selected = confirmed.has(picker.dataset.productId || '') &&
      (radios.some(input => input.checked && !input.disabled && input.dataset.optionAvailable !== "false") || selects.some(select => select.selectedIndex >= 0 && !!select.value && !select.selectedOptions[0]?.disabled));
    if (!selected) {
      event.preventDefault();
      event.stopImmediatePropagation();
      (radios[0] || selects[0])?.focus();
    }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  else syncAll();
  const observer = new MutationObserver(() => syncAll());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();